import { axiosInstance } from "../../utils/axios";

export const getAllCartera = async (params) => {
    const response = await axiosInstance.get("api/v1/collections/queryset-v2/", {
        params,
    });
    return response.data;
};

export const getContacts = async (proscai_id) => {
    const response = await axiosInstance.get(`api/v1/collections/show-contacts/?proscai_id=${proscai_id}`);
    return response.data;
};